import React from 'react';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';

import WhatsAppContact from './WhatsAppContact';
import * as S from './Footer.styled';

const LetsTalk = () => {
  const { t } = useTranslation(['footer'], { useSuspense: false });
  return (
    <S.ContactBlock>
      <S.FooterItemsTitle>{t('letsTalk')}</S.FooterItemsTitle>
      <S.FooterItems>
        <WhatsAppContact />
        <a
          id="genericEmail"
          href="mailto:contact@sunhero.com"
          target="_blank"
          rel="noreferrer"
        >
          contact@sunhero.com
        </a>
        <div>
          <Trans i18nKey="fromTo" />
        </div>
      </S.FooterItems>
    </S.ContactBlock>
  );
};

LetsTalk.displayName = 'LetsTalk';
export default LetsTalk;
